import { makeAutoObservable } from 'mobx'
import type { IDropdownItem } from 'shared/ui'
import { type Integration, IntegrationsApi } from 'entities/Integrations'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { SendFromStore, type ISendFromStoreItem } from 'widgets/SendFrom'

export class TriggerSendFromStore {
  readonly sendFromStore: SendFromStore

  constructor(private _entities: IEntitiesStore) {
    this.sendFromStore = new SendFromStore(this._entities, {
      excludeDeprioritizedNumbers: true,
    })

    makeAutoObservable(this)
  }

  updateIntegrationSenders = async (integration?: Integration) => {
    const integrationSenders: IDropdownItem<ISendFromStoreItem>[] = []

    if (integration) {
      const user = this._entities.usersStore.user
      if (!user?.isOwnerRole) return

      if (integration.key === 'infusionsoft') {
        integrationSenders.push({
          id: 'from_integration',
          label: 'Lead owner',
          iconL: integration.icon,
          data: {
            noLabelInfo: true,
            integration,
          },
        })
        this.sendFromStore.setTopDropdownItems(integrationSenders)
        return
      }

      if (integration.key === 'hubspot') {
        try {
          this.sendFromStore.setLoading(true)
          const { data: fields } = await IntegrationsApi.getIntegrationsByKeyFields(integration.key)
          const ownerFields = fields.filter((field) => field?.referencedObjectType === 'OWNER')
          const ownerFieldsItems: IDropdownItem<ISendFromStoreItem>[] = ownerFields.map(
            (field) => ({
              id: field.name,
              label: field.label,
              value: field.name,
              data: {
                mergeField: field,
                integration,
                parentIcon: integration.icon,
                parentLabel: 'User property',
              },
            })
          )

          if (!ownerFieldsItems.length) return

          integrationSenders.push({
            id: 'from_integration',
            label: 'User property',
            iconL: integration.icon,
            data: { integration },
            children: ownerFieldsItems,
            iconR: 'chevronRight',
            childrenDropdownProps: {
              width: 292,
              TransitionProps: {
                timeout: 100,
              },
            },
          })
          this.sendFromStore.setTopDropdownItems(integrationSenders)
        } catch (e) {
          console.log(e)
        } finally {
          this.sendFromStore.setLoading(false)
        }
      }
    }
  }
}
